import Query from "../utils/Query";

export default class NotificationService {

	static getAll(mainUserId) {
		return Query.get('/items/notification?fields=*,created_by.id,created_by.screen_name,created_by.first_name,created_by.last_name,created_by.last_access_on,created_by.avatar.private_hash,from.*,from.avatar.private_hash,activity.*&meta=filter_count&meta=filter_count&filter[to]=' + mainUserId + '&sort=-id');
	}

	static get(mainUserId, id) {
		return Query.get('/items/notification?fields=*,created_by.id,created_by.screen_name,created_by.first_name,created_by.last_name,created_by.avatar.private_hash,created_by.last_access_on,from.*,from.avatar.private_hash,activity.*&meta=filter_count&meta=filter_count&filter[to]=' + mainUserId + '&filter[id]=' + id + '&single=1');
	}

	static acknowledge(ids = []) {
		return Query.post('/custom/notification/acknowledge/' + ids.join(','));
	}
}
